<template lang="pug">
#bloco-protocolos-analise-relatorio-rastreabilidade
    h3 {{ $t('mensagens.relatorioRastreabilidade.cadastro.selecioneProtocoloDesejaAnalisar') }}
    el-card.protocolos-analise-relatorio-rastreabilidade__card
        el-form(
            :model='formularioProtocolo',
            :rules='protocoloRule',
            ref='formularioProtocolo'
        )
            el-form-item.col-12(prop='idProtocoloSelecionado')
                .protocolo-analise__item
                    el-radio-group(
                        v-model='formularioProtocolo.idProtocoloSelecionado',
                        @change='handleRadioChange',
                        :disabled='bloquearEdicao'
                    )
                        el-radio(
                            v-for='(protocolo, index) in protocolos',
                            :key='protocolo.id',
                            :value='protocolo.id',
                            :label='protocolo.id',
                            v-loading='protocoloLoading'
                        ) {{ protocolo.nome }}
</template>
<script>
import ProtocoloService from '@/services/ProtocoloService';
import i18n from '@/main';

export default {
    name: 'BlocoProtocolosAnaliseRelatorio',

    components: {},

    props: {
        bloquearEdicao: {
            type: Boolean,
            default: false
        },
        dadosEdicao: {
            type: Object,
            required: false
        }
    },

    data() {
        return {
            formularioProtocolo: {
                idProtocoloSelecionado: ''
            },
            protocolos: [],
            protocoloLoading: false,
            protocoloRule: {
                idProtocoloSelecionado: [
                    {
                        required: true,
                        message: this.$t(
                            'mensagens.relatorioRastreabilidade.cadastro.campoObrigatorio'
                        ),
                        trigger: 'change'
                    }
                ]
            }
        };
    },
    mounted() {
        this.buscarProtocolo();
    },
    computed: {
        locale: function () {
            return i18n._vm.locale;
        }
    },
    watch: {
        dadosEdicao: {
            handler() {
                if (this.dadosEdicao) {
                    this.preencherCamposParaEdicao();
                }
            },
            immediate: true
        },
        locale: function () {
            this.protocoloRule.idProtocoloSelecionado[0].message = this.$t(
                'mensagens.relatorioRastreabilidade.cadastro.campoObrigatorio'
            );
        }
    },
    methods: {
        handleRadioChange() {
            if (this.formularioProtocolo.idProtocoloSelecionado !== null) {
                this.$emit(
                    'protocoloSelecionado',
                    this.formularioProtocolo.idProtocoloSelecionado
                );
            } else {
                return false;
            }
        },
        async buscarProtocolo() {
            this.protocoloLoading = true;
            try {
                const { data } = await ProtocoloService.buscarProtocolos();
                this.protocolos = data;
                this.protocoloLoading = false;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.relatorioRastreabilidade.cadastro.erroBuscarProtocolos'
                    )
                );
                this.protocoloLoading = false;
            }
        },

        validateForm() {
            this.$refs['formularioProtocolo'].validate(valid => {
                if (valid) {
                } else {
                    this.$emit('handleValidationFailed');
                }
            });
        },
        preencherCamposParaEdicao() {
            this.formularioProtocolo.idProtocoloSelecionado =
                this.dadosEdicao.idProtocolo;
        }
    }
};
</script>
<style lang="scss">
body {
    overflow-y: hidden;
    overflow-x: hidden;
}
#bloco-protocolos-analise-relatorio-rastreabilidade {
    h3 {
        font-weight: bold;
        font-size: 16px;
        margin-bottom: 10px;
    }
    .el-card__body {
        padding: 16px;
    }
    .row {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        margin-right: -15px;
        margin-left: -15px;
        justify-content: space-between;
        gap: 16px;

        .el-form-item {
            margin-bottom: 8px;
            flex: 1;

            .el-select {
                display: flex;
                position: relative;
            }
        }
    }

    .protocolos-analise-relatorio-rastreabilidade__listagem {
        display: flex;
        gap: 40px;
    }

    .protocolo-analise__item {
        display: flex;
        align-items: center;
        gap: 40px;
    }

    .el-card.protocolos-analise-relatorio-rastreabilidade__card.is-always-shadow {
        min-height: 58px;
        display: flex;
        align-items: center;

        .el-card__body {
            padding: 16px;
            margin-top: 10px;

            .el-form-item__error {
                min-width: 100px;
            }
        }
    }
}
</style>
